import { OrgBookings } from "@/components/corporate/organizations/page/OrgBookings";
import { TournamentsTab } from "@/components/corporate/organizations/TournamentsTab";

interface OrgActivityTabProps {
  organizationId: string;
}

/** Activity: this company's bookings, then its tournaments (unchanged). */
export function OrgActivityTab({ organizationId }: OrgActivityTabProps) {
  return (
    <div className="space-y-8" data-testid="org-activity">
      <OrgBookings organizationId={organizationId} />
      <section className="space-y-3" data-testid="org-tournaments">
        <TournamentsTab organizationId={organizationId} />
      </section>
    </div>
  );
}

export default OrgActivityTab;
